<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="row">
          <div class="col-md-3">
            <div class="card">
            <div class="card-header bg-primary rounded-1 text-white">{{ service }}</div>
            <div class="card-body p-2">
              <div class=" mb-2 d-flex justify-content-between">
                <img class="img-rounded" src="@/assets/images/sick.png" height="50px" />
                <span><a @click="$router.go(-1)" type="button" class="btn-sm btn btn-primary"> <i class="mdi mdi-undo"></i> back</a></span>
              </div>
              <span v-if="patientspinner==false">
              <table v-for="item in patients" :key="item.id" class="table">
              <tr><td>Full Name </td><td> <b class="text-primary h7">{{ item.name }} </b></td></tr>
              <tr><td>Gender </td><td> <span class="text-primary h7">{{ item.gender }} </span></td></tr>
              <tr><td> Telephone </td><td> <span class="text-primary h7">0{{ item.telephone }} </span></td></tr>
              <tr><td> Age </td><td> <span class="text-primary h7">{{ getAge(item.date_of_birth) }} yrs </span></td></tr>
              <tr><td> Address </td><td> <span class="text-primary h7">{{ item.address }} </span></td></tr>
              <tr><td> Nationality </td><td> <span class="text-primary h7">{{ item.nationality }} </span></td></tr>
              </table>
              <h5 class="my-3"><i class="mdi mdi-calendar"></i> &nbsp;&nbsp; {{ visit_date }}</h5>
              <div class="card">
                <div class="card-header bg-primary rounded-3 text-white">Triage</div>
                <div class="card-body px-3 py-1">
                  <table v-for="item in triages" :key="item.id" class="table">
                  <tr><td>Temperature </td><td> <span class="text-primary h7">{{ item.temperature }} ℃</span></td></tr>
                  <tr><td>Weight </td><td> <span class="text-primary h7">{{ item.weight }} Kgs</span></td></tr>
                  <tr><td> Height </td><td> <span class="text-primary h7">{{ item.height }} cm</span></td></tr>
                  <tr><td> Muac</td><td> <span class="text-primary h7">{{ item.muac }} cm</span></td></tr>
                  <tr><td> Blood Pressure </td><td> <span class="text-primary h7">{{ item.bloodpressure }} mmHg</span></td></tr>
                  <tr><td> Pulse </td><td> <span class="text-primary h7">{{ item.pulse }} b/min</span></td></tr>
                  </table>
                </div>
              </div>
              </span>
              <span v-else><i class="fas fa-spinner fa-3x p-5 text-primary fa-spin"></i></span>
            </div>
            </div>
          </div>
          <div class="col-md-9">
            <b-tabs pills nav-class="p-0" content-class="text-dark">
              <b-tab active class="border-0">
                <template v-slot:title>Treatment</template>
                <div class="card">
                  <div class="card-body">
                    <span v-if="treatments.length>0">
                      <b>Presented complaints: </b>
                      <span class="text-black" v-html="symptoms"></span><br>
                      <b>History of Presented Complaints: </b>
                      <span class="text-black" v-html="history"></span><br>
                      <b>General Examination to Review of Systems</b>
                      <p class="my-0 small text-muted">(Musculoskeletal, Nerves, Abdomen & Cardiac system, Nose & Throat)</p>
                      <span class="text-black" v-html="examination"></span><br>
                      <b>Provisional Diagnosis: </b>
                      <span class="text-black" v-html="diagnosis"></span><br>
                      <b>Recommendation: </b>
                      <span class="text-black" v-html="recommedation"></span>
                    </span>
                    <span v-else>
                      <form @submit.prevent="addTreatment">
                        <label class="mt-2">Presenting complaints</label>
                        <tinymce id="d1" v-model="symptoms"></tinymce>
                        <label class="mt-2">History of Presented Complaints</label>
                        <tinymce id="d2" v-model="history" :toolbar="'undo redo'"></tinymce>
                        <label class="mt-2 mb-0">General Examination to Review of Systems</label>
                        <p class="my-0 small text-muted">(Musculoskeletal, Nerves, Abdomen & Cardiac system, Nose & Throat)</p>
                        <tinymce id="d3" v-model="examination"></tinymce>
                        <label class="mt-2">Provisional Diagnosis</label>
                        <tinymce id="d4" v-model="diagnosis"></tinymce>
                        <label class="mt-2">Recommendation</label>
                        <tinymce id="d5" v-model="recommedation"></tinymce>
                        <div class="form-group mt-2">
                          <label>Patient Type</label> <small class="text-danger">*</small>
                          <b-form-select class="form-control" v-model="patient_type">
                            <option value="1">Out Patient</option><option value="2">In Patient</option>
                          </b-form-select>
                        </div>
                        <div class="form-group d-flex justify-content-between mt-2">
                          <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
                        </div>
                      </form>
                    </span>
                    <br><br>
                    <span v-show="treatments.length>0"><router-link :to="{ path: '/printtreatment',  query: { id: this.$route.query.id }}" type="button" class="btn-sm btn btn-info"> <i class="mdi mdi-printer"></i> Print Treatment</router-link></span>
                  </div>
                </div>
              </b-tab>
              <b-tab class="border-0">
                  <template v-slot:title>Presciptions</template>
                  <div class="card">
                    <div class="card-body">
                      <b-button v-b-modal.new-prescription size="sm" variant="primary"><i class="mdi mdi-plus"></i> New Prescription</b-button>
                      <table class="table table-sm mt-2" style="color: black;" density="compact">
                        <thead><tr><th>Medicine</th><th>Dosage</th><th>Note</th></tr></thead>
                      <tbody>
                        <tr v-for="item in prescriptions" :key="item.id">
                          <td>{{ item.medicine.name }} </td>
                          <td>{{ item.dosage }}</td>
                          <td>{{ item.note }}</td>
                          <td>
                            <span v-if="item.status==1">
                              <b-button @click="deleti(item.id)" type="button" class="btn-sm btn" variant="danger"  v-b-modal.delete> <i class="mdi mdi-trash-can"></i> </b-button>
                            </span>
                            <span v-else>
                              <b-button type="button" class="btn-sm btn" variant="primary" v-b-modal.edit> <i class="mdi mdi-check-circle"></i></b-button>
                            </span>
                          </td>
                        </tr>
                      </tbody>
                      </table>
                    </div>
                  </div>
              </b-tab>
              <b-tab class="border-0">
                <template v-slot:title>Services</template>
                <div class="card">
                  <div class="card-body">
                      <div class="d-flex justify-content-start">
                        <b-button v-b-modal.new-lab-service size="sm" @click="FindCategory(4)" variant="info"><i class="mdi mdi-plus"></i> Lab Service</b-button>
                        <b-button v-b-modal.new-radiology-service size="sm" class="mx-2" @click="FindCategory(3)" variant="primary"><i class="mdi mdi-plus"></i> Radiology Service</b-button>
                        <b-button v-b-modal.new-service size="sm" variant="dark"><i class="mdi mdi-plus"></i> Other Services</b-button>
                      </div>
                      <table class="table table-sm mt-2" style="color: black;" density="compact">
                      <thead><tr><th>Category</th><th>Service Name</th><th>Service Price</th><th>Status</th></tr></thead>
                      <tbody>
                        <tr v-for="item in services" :key="item.id">
                          <td>{{ item.service_category.name }} </td>
                          <td>{{ item.service_name.name }}</td>
                          <td>{{ item.service_price }}</td>
                          <td>
                            <span v-if="item.status==1">
                              <b-button @click="remove(item.id,item.service_name.name)" type="button" class="btn-sm btn" variant="danger"  v-b-modal.delete> <i class="mdi mdi-trash-can"></i> </b-button>
                            </span>
                            <span v-else>
                              <b-button @click="edit(item.service_name.id,item.service_name.name,item.service_category.id )" type="button" class="btn-sm btn" variant="primary" v-b-modal.edit> <i class="mdi mdi-clipboard-list"></i> results </b-button>
                            </span>
                          </td>
                        </tr>
                      </tbody>
                      </table>
                  </div>
                </div>
              </b-tab>
              <b-tab class="border-0">
                <template v-slot:title>Diagnosis</template>
                <div class="card">
                  <div class="card-body">
                      <b-button v-b-modal.new-diagnosis size="sm" variant="primary"><i class="mdi mdi-plus"></i> Add Diagnosis</b-button>
                      <table class="table table-sm mt-2" style="color: black;" density="compact">
                      <thead><tr><th>Diagnosis</th><th>Diagnosed by</th><th>Diagnosed on</th></tr></thead>
                      <tbody>
                        <tr v-for="item in diagnoses" :key="item.id">
                            <td>{{ item.disease.name }} </td>
                            <td>{{ item.addedby.full_name }}</td>
                            <td>{{ item.diagnosisdate }}</td>
                        </tr>
                      </tbody>
                      </table>
                  </div>
                </div>
              </b-tab>
              <b-tab class="border-0">
                  <template v-slot:title>Appointments</template>
                  <div class="card">
                  <div class="card-body">
                    <table class="table table-sm mt-2" style="color: black;" density="compact">
                    <thead><tr><th>Appointment Date</th><th>Appointment Time</th><th>Status</th></tr></thead>
                    <tbody>
                      <tr v-for="item in appointments" :key="item.id">
                          <td>{{ item.appointment_date }}</td>
                          <td>{{ item.appointment_time }}</td>
                          <td>
                            <span v-if="item.status==1">
                              <span class="btn btn-sm btn-danger">Pending</span>
                            </span>
                            <span v-else>
                              <span class="btn btn-sm btn-primary">Completed</span>
                            </span>
                          </td>
                      </tr>
                    </tbody>
                    </table>
                  </div>
                </div>
              </b-tab>
              <b-tab class="border-0">
                <template v-slot:title>Patient History</template>
                <div class="card">
                  <div class="card-body">
                    <div class="card" v-for="item in visits" :key="item.id">
                      <b-card no-body class="mb-1">
                      <b-card-header header-tag="header" role="tab">
                        <h6 class="m-0"><a v-b-toggle="'accordion-'+item.id" class="text-dark" href="javascript: void(0);"><i class="mdi mdi-calendar"></i> {{ item.addedon }} <b class="text-black">{{ item.service_category.name }}</b> <b class="text-info">{{ item.service_name.name }}</b></a>
                          <span v-if="item.service_category.id==4">
                            <span v-if="item.lab==0"><span class="btn btn-sm btn-danger"> Not Worked On</span></span>
                          <span v-else><span class="btn btn-sm btn-primary"> Worked On</span></span>
                          </span>
                          <span v-else class="ms-2"> <span v-if="item.treatment==0"><span class="btn btn-sm btn-danger"> Not Worked On</span></span>
                          <span v-else><span class="btn btn-sm btn-primary"> Worked On</span></span></span>
                        </h6>
                      </b-card-header>
                      <b-collapse :id="'accordion-'+item.id" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                          <div v-if="item.treatment==0 && item.lab==0">
                            <span class="p-3"> No Details yet</span>
                          </div>
                          <div v-else>
                          <b-card-text v-if="item.service_category.id==4">
                            <b>Results: </b>
                            <span class="text-black" v-html="item.lab.result"></span><br>
                            <b>Worked on by: </b>
                            <span class="text-black" v-html="item.addedby.full_name"></span>
                          </b-card-text>
                          <b-card-text v-else>
                            <span v-if="item.service_category.id==3">
                              <b>Results: </b>
                              <span class="text-black" v-html="item.treatment.diagnosis"></span><br>
                            </span>
                            <span v-else>
                            <b>Diagnosis: </b>
                            <span class="text-black" v-html="item.treatment.diagnosis"></span><br>
                            <b>Examination: </b>
                            <span class="text-black" v-html="item.treatment.examination"></span><br>
                            <b>Recommendation: </b>
                            <span class="text-black" v-html="item.treatment.recommedation"></span>
                            <b>Worked on by: </b>
                            <span class="text-black" v-html="item.addedby.full_name"></span>
                          </span>
                          </b-card-text>
                        </div>
                        </b-card-body>
                      </b-collapse>
                    </b-card>
                    </div>
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="new-service" size="md" title="New Service" title-class="font-14" hide-footer>
      <form @submit.prevent="AddPatientService">
        <div class="form-group mb-2">
          <label>Service Category</label> <small class="text-danger">*</small>
          <multiselect v-model="service_category" @input="FilterCategory" :options="servicecategories" label="name"></multiselect>
        </div>
        <div class="form-group mb-2">
          <label>Service Name</label> <small class="text-danger">*</small>
          <multiselect v-model="service_name" label="name" @input="FilterServicePrice" :options="newservices"></multiselect>
        </div>
        <div class="form-group mb-2">
          <label>Service Cost</label> <small class="text-danger">*</small>
          <input v-model="service_price" readonly required type="number" class="form-control" />
        </div>
        <b>Notes</b>
        <textarea v-model="notes" rows="2" class="form-control"></textarea>
        <br><span class="text-danger">{{ saveerror }}</span>
      <div class="form-group d-flex justify-content-end">
        <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-service')" >Close</b-button>
        <b-button type="submit" :disabled="savebtn <= false" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
      </div>
    </form>
    </b-modal>

    <b-modal id="new-lab-service" size="md" title="New Lab Service" title-class="font-14" hide-footer>
      <form @submit.prevent="AddPatientService">
        <div class="form-group mb-2">
          <label>Test Name</label> <small class="text-danger">*</small>
          <multiselect v-model="service_name" label="name" @input="FilterServicePrice" :options="newservices"></multiselect>
        </div>
        <div class="form-group mb-2">
          <label>Service Cost</label> <small class="text-danger">*</small>
          <input v-model="service_price" readonly required type="number" class="form-control" />
        </div>
        <b>Notes</b>
        <textarea v-model="notes" rows="2" class="form-control"></textarea>
        <br><span class="text-danger">{{ saveerror }}</span>
      <div class="form-group d-flex justify-content-end">
        <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-service')" >Close</b-button>
        <b-button type="submit" :disabled="savebtn <= false" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
      </div>
    </form>
    </b-modal>

    <b-modal id="new-radiology-service" size="md" title="New Radiology Service" title-class="font-14" hide-footer>
      <form @submit.prevent="AddPatientService">
        <div class="form-group mb-2">
          <label>Service Name</label> <small class="text-danger">*</small>
          <multiselect v-model="service_name" label="name" @input="FilterServicePrice" :options="newservices"></multiselect>
        </div>
        <div class="form-group mb-2">
          <label>Service Cost</label> <small class="text-danger">*</small>
          <input v-model="service_price" readonly required type="number" class="form-control" />
        </div>
        <b>Notes</b>
        <textarea v-model="notes" rows="2" class="form-control"></textarea>
        <br><span class="text-danger">{{ saveerror }}</span>
      <div class="form-group d-flex justify-content-end">
        <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-service')" >Close</b-button>
        <b-button type="submit" :disabled="savebtn <= false" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
      </div>
    </form>
    </b-modal>

    <b-modal id="new-diagnosis" size="md" title="New Diagnosis" title-class="font-14" hide-footer>
      <form @submit.prevent="AddPatientDiagnosis">
        <div class="form-group mb-2">
          <label>Diagnosis</label> <small class="text-danger">*</small>
          <multiselect v-model="diagnosisname" :options="diseases" label="name"></multiselect>
        </div>
        <div class="form-group mb-2">
          <label> Diagnosis Date</label> <small class="text-danger">*</small>
          <input v-model="diagnosisdate" required type="date" class="form-control" />
        </div>
      <div class="form-group d-flex justify-content-end">
        <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-diagnosis')" >Close</b-button>
        <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
      </div>
    </form>
    </b-modal>

    <b-modal id="new-prescription" centered title="New Prescription" title-class="font-18" hide-footer>
          <form @submit.prevent="addPrescription">
            <div class="form-group mb-2">
              <label>Medicine</label>
                <multiselect v-model="medicine" @input="FilterProductUnits" :options="products" label="name"></multiselect>
              </div>
              <div class="row">
              <div class="col-md-6">
              <label>Unit</label>
                <multiselect v-model="unit" @input="FilterPrice" :options="units" label="unit"></multiselect>
              </div>
              <div class="col-md-6">
              <label>Price</label>
                <input v-model="price" type="number" readonly class="form-control" />
              </div>
              </div>
              <div class="row">
                <div class="col-4">
                  <label>Dose</label>
                  <input v-model="dose" type="number"  @input="CheckMedicine" min="1" required class="form-control" />
                </div>
                <div class="col-4">
                  <label>Frequency</label>
                  <input v-model="frequency" type="number" @input="CheckMedicine" min="1" required class="form-control" />
                </div>
                <div class="col-4">
                  <label>Duration</label>
                  <input v-model="duration" type="number" @input="CheckMedicine" min="1" required class="form-control" />
                </div>
              </div>
              <div class="form-group mb-2">
              <label>Total Amount</label>
                <input v-model="totalprice" type="number" readonly class="form-control" />
              </div>
              <div class="form-group mb-2">
              <label>Prescription Note</label>
              <textarea v-model="note" rows="2" class="form-control" />
              </div>
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-prescription')" >Close</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
              </div>
          </form>
      </b-modal>

    <b-modal id="view-results" centered :title="resultname" title-class="font-14" hide-footer>
      <span v-for="item in treatmentresults" :key="item.id">
        <div class="row">
          <div class="col-md-6">
            <span>Presented Complaints <span class="text-info h5" v-html="item.symptoms"></span></span>
            <span>History of Presented Complaints <span class="text-info h5" v-html="item.history"></span></span>
            <span>General Examination to Review of Systems <span class="text-info h5" v-html="item.examination"></span></span>
          </div>
          <div class="col-md-6" style="border-left: 1px solid grey;">
            <span>Provisional Diagnosis <span class="text-info h5" v-html="item.diagnosis"></span></span>
            <span>Recommendation <span class="text-info h5" v-html="item.recommedation"></span></span>
          </div>
        </div>
      </span>
    </b-modal>

    <b-modal id="lab-results" centered :title="resultname" title-class="font-14" hide-footer>
      <span v-for="item in labresults" :key="item.id">
        <h5 class="">Results :</h5>
        <span class="text-info" v-html="item.result"></span>
        <br><br><span class="h6">Date Recorded : <span class="text-info h5" v-html="item.daterecorded"></span></span>
      </span>
    </b-modal>

    <b-modal id="scan-results" centered :title="resultname" title-class="font-14" hide-footer>
      <span v-for="item in scanresults" :key="item.id">
        <h5 class="">Results :</h5>
        <span class="text-info" v-html="item.diagnosis"></span>
      </span>
    </b-modal>

    <b-modal id="delete-service" centered title="Delete Service" title-class="font-18" hide-footer>
        <form @submit.prevent="removeService">
            <input v-model="id" type="hidden">
              Are you sure you want to delete the Service : <b>{{ servicename }}</b> ?
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('delete-service')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> YES</b-button>
            </div>
        </form>
    </b-modal>

    <b-modal id="delete-prescription" centered title="Delete Prescription" title-class="font-18" hide-footer>
        <form @submit.prevent="removePrescription">
            <input v-model="id" type="hidden">
              Are you sure you want to delete the Prescription ?
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('delete-prescription')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> YES</b-button>
            </div>
        </form>
    </b-modal>

  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import Multiselect from "vue-multiselect";
import { productMethods, productComputed, diseaseMethods, diseaseComputed, serviceCategoryMethods,serviceCategoryComputed} from "@/state/helpers";

export default {
  page: {
    title: "Patient Treatment",
    meta: [{name: "description",content: appConfig.description,},],
  },
  components: {
    Layout,Multiselect,
  },
  data() {
    return {
      title: "Patient Treatment",
      items: [{text: "Dashboard",to: "/",},{text: "Patients",active: true,},],
      patients:[],
      patientsymptoms:[],
      patientdiseases:[],
      prescriptions:[],
      appointments:[],
      diagnosis:[],
      symptoms:[],
      triages:[],
      services:[],
      visits:[],
      newservices:[],
      patientspinner:true,
      patientid:'',
      visitid:'',
      service:'',
      service_id:'',
      recommedation:'',
      examination:'',
      history:'',
      medicine:'',
      price:'',
      quantity:'',
      dose:'1',
      frequency:'1',
      duration:'1',
      note:'',
      units:[],
      unit:'',
      totalprice:'',
      service_category:[],
      service_name:[],
      service_price:'',
      patient_type:'1',
      resultid:'',
      resultname:'',
      treatmentresults:[],
      labresults:[],
      scanresults:[],
      savebtn:true,
      saveerror:'',
      savebtn1:true,
      saveerror1:'',
      diagnosisname:'',
      diagnosisdate:new Date().toLocaleDateString('fr-CA'),
      diagnoses:[],
      serviceid:'',
      servicename:'',
      prescriptionid:'',
      prescriptionname:'',
      cat_id:'',
      visit_date:'',
      treatments:[],
      notes:'',
    };
  },
  computed: {
      ...productComputed,
      ...diseaseComputed,
      ...serviceCategoryComputed,
  },
  created() {
    this.fetchServiceCategory();
    this.fetchInfo();
    this.fetchDiseases();
  },
  methods: {
    ...productMethods,
    ...diseaseMethods,
    ...serviceCategoryMethods,
    getAge(dateString){
      let birth = new Date(dateString); let now = new Date(); let beforeBirth = ((() => {birth.setDate(now.getDate());birth.setMonth(now.getMonth()); return birth.getTime()})() < birth.getTime()) ? 0 : 1;
      return now.getFullYear() - birth.getFullYear() - beforeBirth;
    },
    async edit(id,name,category){
      this.resultid=id;
      this.resultname=name;
      if (category==4) {
        let url = `/patientlabresults/${this.patientid},${this.visitid},${this.resultid}`;
        await axios.get(url).then((response) => { this.labresults = response.data.results; });
        this.$bvModal.show('lab-results');
      } else if (category==3) {
        let url = `/profiletreatment/${this.patientid},${this.visitid},${this.resultid}`;
        await axios.get(url).then((response) => { this.scanresults = response.data.treatments; });
        this.$bvModal.show('scan-results');
      } else {
        let url = `/profiletreatment/${this.patientid},${this.visitid},${this.resultid}`;
        await axios.get(url).then((response) => { this.treatmentresults = response.data.treatments; });
        this.$bvModal.show('view-results');
      }
    },
    remove(serviceid,servicename){
      this.serviceid=serviceid;
      this.servicename=servicename;
      this.$bvModal.show('delete-service')
    },
    deleti(id){
      this.prescriptionid=id;
      this.$bvModal.show('delete-prescription')
    },
    async fetchInfo(){
      this.id=this.$route.query.id;
      let url = `/visitinfo/${this.id}`;
      await axios.get(url).then((response) => {
        this.patientid = response.data.visits[0].patient.patient_id;
        this.visitid = response.data.visits[0].visit_id;
        this.service = response.data.visits[0].service_name.name;
        this.service_id = response.data.visits[0].service_name.id;
        this.visit_date = response.data.visits[0].addedon;
        this.showpatient();
        this.showtprescriptions();
        this.showtreatments();
        this.showtriages();
        this.showservices();
        this.showvisits();
        this.fetchProducts();
      });
    },
    async FilterCategory(){
      let url = `/servicebycategory/${this.service_category.id}`;
        await axios.get(url).then((response) => {
        this.newservices = response.data.services;
      });
    },
    async FindCategory(cat_id){
      this.cat_id = cat_id;
      let url = `/servicebycategory/${this.cat_id}`;
        await axios.get(url).then((response) => {
        this.newservices = response.data.services;
      });
    },
    async FilterServicePrice(){
      let url = `/serviceprice/${this.service_name.id}`;
      await axios.get(url).then((response) => {
        this.service_price = response.data.price;
      });
    },
    CheckMedicine(){
      this.totalprice = this.price*this.dose*this.frequency*this.duration;
    },
    async FilterProductUnits(){
        let url = `/unitsbyproduct/${this.medicine.id}`;
        await axios.get(url).then((response) => {
          this.units = response.data.units;
          });
    },
    async FilterPrice(){
        let url = `/productbyunitprice/${this.unit.unit_id},${this.medicine.id}`;
        await axios.get(url).then((response) => {
          this.price = response.data.price;
          this.CheckMedicine();
          });
    },
    async showpatient(){
      let url = `/patientprofile/${this.patientid}`;
      await axios.get(url).then((response) => {
        this.patients = response.data.patients;
        this.patientspinner=false;
      });
    },
    async showtriages(){
      let url = `/patienttriages/${this.patientid},${this.visitid}`;
      await axios.get(url).then((response) => {
        this.triages = response.data.triages;
        this.showtappointments();
        this.showdiagnosis();
      });
    },
    async showservices(){
      let url = `/profileservices/${this.patientid},${this.visitid}`;
      await axios.get(url).then((response) => {
        this.services = response.data.visits;
      });
    },
    async showtprescriptions(){
      let url = `/profileprescription/${this.patientid},${this.visitid}`;
      await axios.get(url).then((response) => {
        this.prescriptions = response.data.prescriptions;
      });
    },
    async showtappointments(){
      let url = `/profileappointment/${this.patientid}`;
      await axios.get(url).then((response) => {
        this.appointments = response.data.appointments;
      });
    },
    async showtreatments(){
      let url = `/profiletreatment/${this.patientid},${this.visitid},${this.service_id}`;
      await axios.get(url).then((response) => {
      if (response.data.treatments.length===0) {
        this.symptoms = '';
        this.history = '';
        this.examination = '';
        this.diagnosis = '';
        this.recommedation = '';
      }else{
        this.treatments = response.data.treatments;
        this.symptoms = response.data.treatments[0].symptoms;
        this.history = response.data.treatments[0].history;
        this.examination = response.data.treatments[0].examination;
        this.diagnosis = response.data.treatments[0].diagnosis;
        this.recommedation = response.data.treatments[0].recommedation;
        this.patient_type = response.data.treatments[0].patient_type;
      }
      });
    },
    async showdiagnosis(){
       let url = `/patientdiagnosis/${this.patientid},${this.visitid}`;
      await axios.get(url).then((response) => {
        this.diagnoses = response.data.diagnosis;
      });
    },
    async showvisits(){
      let url = `/profilevisits/${this.patientid}`;
      await axios.get(url).then((response) => {
        this.visits = response.data.visits;
      });
    },
    async removePrescription() { 
    let formData = new FormData();
    formData.append("prescriptionid", this.prescriptionid);
    let url = "/removepatientprescription";
    await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.showtprescriptions();
        this.$bvModal.hide('delete-prescription');
      }
    });
    },
    async removeService() { 
    let formData = new FormData();
    formData.append("serviceid", this.serviceid);
    let url = "/removepatientvisit";
    await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.showservices();
        this.showvisits();
        this.$bvModal.hide('delete-service');
      }
    });
    },
    async AddPatientService() { 
        this.savebtn=false;
        this.saveerror="Saving Patient Visit";
        let formData = new FormData();
        formData.append("patient_id", this.patientid);
        formData.append("visit_id", this.visitid);
        formData.append("service_category", this.service_category.id ?? this.cat_id);
        formData.append("service_name", this.service_name.id);
        formData.append("service_price", this.service_price);
        formData.append("notes", this.notes);
        let url = "/addpatientvisit";
        await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
            this.showservices();
            this.$bvModal.hide('new-service');
            this.$bvModal.hide('new-lab-service');
            this.$bvModal.hide('new-radiology-service');
            this.service_category="";
            this.service_name="";
            this.service_price="";
            this.notes="";
            this.$toast.success("New Patient Service Added");
            this.savebtn=true;
            this.saveerror="";
        }
        });
    },
    async AddPatientDiagnosis() { 
      let formData = new FormData();
      formData.append("patient_id", this.patientid);
      formData.append("visit_id", this.visitid);
      formData.append("diagnosisname", this.diagnosisname.id);
      formData.append("diagnosisdate", this.diagnosisdate);
      let url = "/addpatientdiagnosis";
      await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.showdiagnosis();
        this.$bvModal.hide('new-diagnosis');
        this.diagnosisname="";
        this.$toast.success("New Patient Diagnosis Added");
      }
      });
    },
    async addTreatment() { 
      let formData = new FormData();
      formData.append("patient_id", this.patientid);
      formData.append("visit_id", this.visitid);
      formData.append("service_id", this.service_id);
      formData.append("symptoms", this.symptoms);
      formData.append("history", this.history);
      formData.append("examination", this.examination);
      formData.append("recommedation", this.recommedation);
      formData.append("diagnosis", this.diagnosis);
      formData.append("patient_type", this.patient_type);
      let url = "/addtreatment";
      await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.showtreatments();
        this.showservices();
          this.symptoms="";
          this.history="";
          this.examination="";
          this.recommedation="";
          this.diagnosis="";
          this.patient_type="1";
          this.$toast.success("Patient Treatment Added");
      }
      });
    },
    async addPrescription() {
        let formData = new FormData();
        formData.append("patient_id", this.patientid);
        formData.append("visit_id", this.visitid);
        formData.append("service_id", this.service_id);
        formData.append("medicine", this.medicine.id);
        formData.append("unit", this.unit.unit_id);
        formData.append("dosage", this.dose+" * "+this.frequency+" * "+this.duration );
        formData.append("quantity", this.dose*this.frequency*this.duration );
        formData.append("totalprice", this.totalprice);
        formData.append("note", this.note);
        let url = "/addprescription";
        await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
            this.$bvModal.hide('new-prescription');
            this.showtprescriptions();
            this.medicine="";
            this.dose="";
            this.frequency="";
            this.duration="";
            this.note="";
            this.$toast.success("Patient Prescription Added");
        }
        });
      },
    }
};
</script>